<template>
  <div class="app-navbar">
    <div class="mx-2">
      <div class="app-navbar-wrap">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="navbar__start">
              <div class="app-logo ">
                <router-link
                  to="/"
                  class="nav-link"
                  exact-active-class="is-active"
                >
                  <img
                    src="/main-color.png"
                    alt="منصه بلدي"
                    style="width: 200px"
                  />
                </router-link>
              </div>
            </div>
          </div>
       
          <div>
            <div class="navbar__end">
              <div class="user-data">
                <b-dropdown right no-caret>
                  <template #button-content>
                    <div class="user-info">
                      <!-- Mobile: Show only icon -->
                      <div class="mobile-user-icon d-md-none">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor"/>
                          <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" fill="currentColor"/>
                        </svg>
                      </div>
                      
                      <!-- Desktop: Show email text -->
                      <div class="user-content d-none d-md-block" v-if="userData">
                        <p>
                          {{ userData.email }}
                          <img
                            src="@/assets/icons/angle-down.svg"
                            class="icon ms-2"
                          />
                        </p>
                      </div>
                    </div>
                  </template>
                  
                  <!-- Dropdown Content -->
                  <div class="user-dropdown-content">
                    <!-- Show email in dropdown for mobile -->
                    <div class="d-md-none mobile-email-info" v-if="userData">
                      <div class="user-email" style="margin: 20px !important;">{{ userData.email }}</div>
                    </div>
                    
                    <b-dropdown-divider class="d-md-none"></b-dropdown-divider>
                    
                    <b-dropdown-item-button @click="showLogoutConfirmation">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
                        <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7Z" fill="currentColor"/>
                        <path d="M2 12C2 6.48 6.48 2 12 2V4C7.58 4 4 7.58 4 12S7.58 20 12 20V22C6.48 22 2 17.52 2 12Z" fill="currentColor"/>
                      </svg>
                      تسجيل الخروج
                    </b-dropdown-item-button>
                  </div>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ConfirmationModal
      ref="logoutConfirmationModal"
      :handle-confirmation="handleLogoutConfirmation"
      :handle-cancel="handleLogoutCancel"
      title="تسجيل الخروج"
      description="هل أنت متأكد أنك تريد تسجيل الخروج؟"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import headerNotification from "./headerNotification";
import ConfirmationModal from "@/views/shared/ConfirmationModal.vue";
import store from "@/store";
export default {
  computed: {
    ...mapGetters(['userData']),
  },
  components: {
    headerNotification,
    ConfirmationModal
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    showLogoutConfirmation() {
      this.$refs.logoutConfirmationModal.openModal();
    },
    async handleLogoutConfirmation() {
      try {
        this.isLoading = true;
        await store.dispatch("user/logout");
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleLogoutCancel() {
      // Optional: Add any cancel logic here
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
